module.exports = __webpack_public_path__ + "img/pamela-reif.8c82aed7.jpg";